import React, { SVGProps } from 'react'

export const IconItalic = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path d="M9.4043 3.02344L7.6748 12.9766H6L7.72949 3.02344H9.4043Z" fill="currentColor" />
  </svg>
)
